import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { TenantWarningListMaintenanceDto } from './TenantWarningListMaintenanceDto';
import { TenantWarningItemMaintenanceDto } from './TenantWarningItemMaintenanceDto';
import { BaseMaintenanceController } from '../../_base/BaseMaintenanceController';
import { AlertService } from '../../../../services/alert/alert.service';
import { LoadingService } from '../../../../services/loading/loading.service';
import { WarningCustomCodeDto } from '@shared/src/dtos/warning/WarningCustomCodeDto';
import { Observable } from 'rxjs';


@Injectable()
export class TenantWarningMaintenanceController extends
    BaseMaintenanceController<TenantWarningListMaintenanceDto, TenantWarningItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "system/securityandnotifications/warning");
    }


    public getResourceRoot(): string {
        return "WARNING";
    }

    public getWarningCustomCode(ambitid: number): Observable<WarningCustomCodeDto> {
        return this.get(this.getBaseUrl() + "/code/" + ambitid);
    }

    public compileCode(data: WarningCustomCodeDto): Observable<WarningCustomCodeDto> {
        return this.post(this.getBaseUrl() + "/compilecode", data, "compileCode");
    }

    public saveCode(data: WarningCustomCodeDto): Observable<WarningCustomCodeDto> {
        return this.post(this.getBaseUrl() + "/savecode", data, "saveCode");
    }

    public buildUrl(uri: string): string {
        return "/system/securityandnotifications/warning" + uri;
    }

}
